import { Collection, IModel, Metamodel, Named, OwnedSet, Parameter } from 'shell-models-lib';

// This resource is for adding GlobalParameters to the ARM template for CICD. This will NOT be used on the UI and will NOT be included in publishing
@Metamodel.model({
    name: 'globalparameters',
    referable: true,
    reusable: true
})
export class GlobalParametersARM extends Named {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        type: Parameter.MODEL,
        collection: Collection.Set,
    })
    public readonly parameters = OwnedSet.create<Parameter>(this);

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
